import axios from 'axios';
import authHeader from "@/services/auth-header";
import ConstApiUrls from "@/services/const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL_UMKM

class FUmkmService {
    getApiUrl() {
        return API_URL
    }
    getAllFUmkm(){
        return axios.get(API_URL + `getAllFUmkm`, { headers: authHeader() });
    }
    getAllFUmkmPublic(){
        return axios.get(API_URL + `public/getAllFUmkm`, { headers: authHeader() });
    }
    getAllFUmkmContaining(page, pageSize, sortBy, order, search){
        // return axios.get(API_URL + `getAllFUmkm`, { headers: authHeaderMultipart() });
        return axios.get(API_URL + `getAllFUmkmContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`, { headers: authHeader() });
    }
    getAllFUmkmContainingPublic(page, pageSize, sortBy, order, search){
        return axios.get(API_URL + `public/getAllFUmkmContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`, { headers: authHeader() });
    }
    getAllFUmkmContainingExt(fumkmFilter){
        return axios.post(API_URL + `getAllFUmkmContainingExt`, fumkmFilter,{ headers: authHeader() });
    }
    getAllFUmkmContainingExtPublic(fumkmFilter){
        return axios.post(API_URL + `public/getAllFUmkmContainingExt`, fumkmFilter,{ headers: authHeader() });
    }

    getAllFUmkmDivisionContaining(page, pageSize, sortBy, order, search, fdivisionBean){
        return axios.get(API_URL + `getAllFUmkmDivisionContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}&fdivisionBean=${fdivisionBean}`, { headers: authHeader() });
    }
    getFUmkmById(id){
        return axios.get(API_URL + `getFUmkmById/${id}`, { headers: authHeader() });
    }
    getAllFUmkmByUserBean(userBean){
        return axios.get(API_URL + `getAllFUmkmByUserBean/${userBean}`, { headers: authHeader() });
    }
    getFUmkmByIdPublic(id){
        return axios.get(API_URL + `public/getFUmkmById/${id}`, { headers: authHeader() });
    }
    updateFUmkm(item){
        return axios.put(API_URL + `updateFUmkm/${item.id}`, item, {headers: authHeader()})
    }
    createFUmkm(item){
        return axios.post(API_URL + `createFUmkm`, item, {headers: authHeader()})
    }
    createFUmkmEmptyPublic(item){
        return axios.post(API_URL + `public/createFUmkmEmpty`, item, {headers: authHeader()})
    }
    deleteFUmkm(id){
        return axios.delete(API_URL + `deleteFUmkm/${id}`, {
            headers: authHeader()
        });
    }
    deleteAllFUmkm(itemIds){
        return axios.delete(API_URL + `deleteAllFUmkm`, {
            headers:  authHeader(),
            data: itemIds
        });
    }


    countAllFUmkmByFAreaBean(){
        return axios.get(API_URL + `public/countAllFUmkmByFAreaBean`, { headers: authHeader() });
    }

}
export default new FUmkmService()